import React from 'react'
import { connect } from 'react-redux'
import { reduxForm, FormSection, Field, FieldArray } from 'redux-form'
import { TextInput, Select, Checkbox, NumericInput, WikiInput } from '../../../components/forms/index'
import SchemaArray from './SchemaArray'
import Button, { ButtonGroup } from '@atlaskit/button'
import { MentionProvider } from '../../../components/index'
import config from '../../../config'

const setDefaults = (schema) => {
  let { properties } = schema
  if (!properties) return {}

  return properties.reduce((result, field) => {
    result[field.id] = field.properties ? setDefaults(field.properties) :  field.default
    return result
  }, {})
}

const DynamicForm = (props) => {

  let { RequestType, isNew, handleSubmit, actionInProgress, cancel } = props
  let { properties, required } = RequestType.inputs  
  let formProps = Object.keys(properties)
  let mentionProvider = MentionProvider(config.mentionsIssue)
  return (
    <form  onSubmit={ handleSubmit } id='dynamicForm'>
      {formProps.map(key => {
        let prop = properties[key]
        switch (prop.type) {              
          case 'object':
            let isNestedRequire = required && required.includes(prop.name)
            return (
              <FormSection key={prop.id} name={prop.id}>
                <Field name='_include' className='ncss-label' label={prop.title} disabled={isNestedRequire} component={Checkbox} title={prop.description} />
                <SchemaObject title={prop.title} schema={prop} />
              </FormSection>
            )
          case 'string':
            return prop.enum
              ? <Field key={prop.id} name={prop.id} component={Select} label={prop.title} 
                    options={prop.enum.map(e => ({ label: e, value: e }))} title={prop.description} placeholder={prop.default} disabled={actionInProgress}/>
              : <Field key={prop.id} name={prop.id} component={TextInput} label={prop.title} title={prop.description} placeholder={prop.default} disabled={actionInProgress}/>              
          case 'textArea':
              return <Field key={prop.id} name={prop.id} component={TextInput} textArea label={prop.title} title={prop.description} placeholder={prop.default} disabled={actionInProgress}/>   
          case 'wiki':
              return <Field key={prop.id}
                            name={prop.id}
                            component={WikiInput}
                            label={prop.title}
                            title={prop.description}
                            placeholder={prop.default}
                            mentionProvider={mentionProvider}
                            className='top-layer'
                            disabled={actionInProgress}
                            />
          case 'boolean':
            return <Field key={prop.id} name={prop.id} component={Checkbox} label={prop.title} title={prop.description} disabled={actionInProgress}/>
          case 'array':
            return <FieldArray key={prop.id} name={prop.id} prop={prop} component={SchemaArray} disabled={actionInProgress}/>
          case 'number':
            return <Field key={prop.id} name={prop.id} component={NumericInput} label={prop.title} title={prop.description} disabled={actionInProgress}/>
          default:
            throw new Error(`unknown prop type ${prop.type} in ${RequestType.description}`)
        }
      })}      
      <br />
      <ButtonGroup>
        <Button type='submit' appearance='primary'>{isNew ? 'Submit' : 'Update'} <i className={`fa ${actionInProgress ? 'fa-circle-o-notch fa-spin' : null}`} /></Button>
        <Button type='button' appearance='link' onClick={cancel}>Cancel</Button>        
      </ButtonGroup>
    </form>
  )
}

const validate = (values, props) => {
  let properties = props.RequestType.inputs.required

  let result = {}
  properties.forEach(field => {
    result[field] = !values[field] ? 'Cannot not be empty' : undefined
  })  
  return result
}

let IssueDynamicForm = reduxForm({
  form: 'request', 
  enableReinitialize: true,
  updateUnregisteredFields: true,
  keepDirty: true,
  validate: validate 
})(DynamicForm)

IssueDynamicForm = connect((state, ownProps) => {

  let initialValues = ownProps.Issue ? ownProps.Issue : setDefaults(ownProps.RequestType.inputs)
  if ( initialValues.undefined ) {
    delete initialValues.undefined
  }  
  return {
    initialValues: {        
        ...initialValues
      },
          
  }  
})((IssueDynamicForm))


export default IssueDynamicForm



// WEBPACK FOOTER //
// ./client/src/serviceDesk/request/forms/DynamicForm.js